import { render, staticRenderFns } from "./ChecklistAcessorioValor.vue?vue&type=template&id=bdf07b50&"
import script from "./ChecklistAcessorioValor.vue?vue&type=script&lang=js&"
export * from "./ChecklistAcessorioValor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports